"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupHeader = void 0;
var Utilities_1 = require("../../Utilities");
var GroupHeader_styles_1 = require("./GroupHeader.styles");
var GroupHeader_base_1 = require("./GroupHeader.base");
exports.GroupHeader = Utilities_1.styled(GroupHeader_base_1.GroupHeaderBase, GroupHeader_styles_1.getStyles, undefined, {
    scope: 'GroupHeader',
});
//# sourceMappingURL=GroupHeader.js.map